import React from "react";
import { AnnouncementsProvider } from "./AnnoucementsContext";
import AnnouncementFilter from "./AnnouncementFilter";
import AnnouncementsList from "./AnnouncementsList";
import AnnouncementForm from "./AnnouncementForm";
import AnnouncementLog from "./AnnouncementLog";
import AnnouncementEvents from "./AnnouncementEvents";

const AnnouncementsPage = () => {
  return (
    <AnnouncementsProvider>
      <AnnouncementFilter />
      <AnnouncementsList />
      <AnnouncementForm />
      <AnnouncementLog />
      <AnnouncementEvents/>
    </AnnouncementsProvider>
  );
};

export default AnnouncementsPage;
